import Call from '@/script/call';
import common from '@/script/store';
import Message from '@/script/Message';
import Vue from 'vue'
import mywebviewnowinv2 from "@/components/mywebviewnowinv2.vue"
export default {
    base64ToArrayBuffer: function (dataURL) {
        let byteString = atob(dataURL.split(',')[1]);
        let arrayBuffer = new ArrayBuffer(byteString.length);
        let uint8Array = new Uint8Array(arrayBuffer);
        for (let
            i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }
        return uint8Array;
    },
    //保存远程图片
    saveRemoteImage: function (url, filePath) {
        return new Promise(callback => {
            let img = new Image();
            img.src = url;
            let _this = this;
            // 加载图片完成后执行转换
            img.onload = () => {
                // 创建一个 canvas 元素
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;

                // 获取 canvas 上下文
                let ctx = canvas.getContext('2d');

                // 绘制图片到 canvas 上
                ctx.drawImage(img, 0, 0);

                // 转换 canvas 为 JPG 格式的 DataURL
                let dataURL = canvas.toDataURL('image/jpeg', 1.0);

                // 调用回调函数并传递转换后的 JPG DataURL
                let buf = _this.base64ToArrayBuffer(dataURL);
                Call.sendSync("fileEvent.write", filePath, buf);
                img = null;
                ctx = null;
                buf = null;
                canvas = null;
                callback(filePath);
            };
        });
    },
    //缩放图片
    reSizeImageRemote: function (url, filePath, width, height) {
        return new Promise(callback => {
            // 创建一个 Image 对象
            let img = new Image();
            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            img.src = url;
            let _this = this;
            img.onload = () => {
                let w = img.width;
                let h = img.height;
                let nw = width;
                let nh = height;
                let dw = parseFloat(width) / parseFloat(w);
                let dh = parseFloat(height) / parseFloat(h);
                if (dw > dh) {
                    nw = w * dh;
                } else {
                    nh = h * dw;
                }
                // console.log("dw", dw, "dh", dh);
                // canvas.style.border = "1px solid #000";
                // document.body.appendChild(canvas);
                let ctx = canvas.getContext('2d');
                // ctx.drawImage(img, 0, 0);
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, nw, nh)
                let xh = 10;
                if (dw > dh) {
                    //补水平方向的
                    ctx.drawImage(img, img.width - xh, 0, xh, img.height, nw - 1, 0, width, height)
                } else {
                    //补竖值方向的
                    ctx.drawImage(img, 0, img.height - xh, img.width, xh, 0, nh - 1, width, height)
                }
                let dataURL = canvas.toDataURL('image/jpeg');
                let buf = _this.base64ToArrayBuffer(dataURL);
                Call.sendSync("fileEvent.write", filePath, buf);
                img = null;
                ctx = null;
                buf = null;
                canvas = null;
                callback(filePath);
            };
        });
    },
    //缩放图片
    reSizeImage: function (data, imageType, filePath, width, height) {
        return new Promise(callback => {
            let blob = new Blob([data], { type: imageType });
            let url = URL.createObjectURL(blob);
            // 创建一个 Image 对象
            let img = new Image();
            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            img.src = url;
            let _this = this;
            img.onload = () => {
                let w = img.width;
                let h = img.height;
                let nw = width;
                let nh = height;
                let dw = parseFloat(width) / parseFloat(w);
                let dh = parseFloat(height) / parseFloat(h);
                if (dw > dh) {
                    nw = w * dh;
                } else {
                    nh = h * dw;
                }
                // console.log("dw", dw, "dh", dh);
                // canvas.style.border = "1px solid #000";
                // document.body.appendChild(canvas);
                let ctx = canvas.getContext('2d');
                // ctx.drawImage(img, 0, 0);
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, nw, nh)
                let xh = 10;
                if (dw > dh) {
                    //补水平方向的
                    ctx.drawImage(img, img.width - xh, 0, xh, img.height, nw - 1, 0, width, height)
                } else {
                    //补竖值方向的
                    ctx.drawImage(img, 0, img.height - xh, img.width, xh, 0, nh - 1, width, height)
                }
                let dataURL = canvas.toDataURL('image/jpeg');
                let buf = _this.base64ToArrayBuffer(dataURL);
                Call.sendSync("fileEvent.write", filePath, buf);
                img = null;
                ctx = null;
                buf = null;
                canvas = null;
                URL.revokeObjectURL(url);
                callback(filePath);
            };
        });
    },
    //视频生成封面图
    videoGenImage: function (url, filePath, width, height) {
        return new Promise(callback => {
            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            let ctx = canvas.getContext('2d');
            let vd = document.createElement('video');
            vd.crossOrigin = 'Anonymous';
            vd.preload = 'auto';
            vd.width = width;
            vd.height = height;
            vd.src = url;
            let _this = this;
            vd.addEventListener('loadeddata', () => {
                // console.log(vd.height);
                // console.log(vd.width);
                ctx.drawImage(vd, 0, 0, width, height);
                let dataURL = canvas.toDataURL('image/jpeg');
                let buf = _this.base64ToArrayBuffer(dataURL);
                Call.sendSync("fileEvent.write", filePath, buf);
                // console.log("视频载入",arr);
                vd = null;
                ctx = null;
                buf = null;
                canvas = null;
                callback(filePath);
            });
        });
    },
    //获得图片的尺寸信息
    imageSize: function (data, imageType) {
        return new Promise(callback => {
            let blob = new Blob([data], { type: imageType });
            let url = URL.createObjectURL(blob);
            // console.log("============================2","write-text",blob)
            // 创建一个 Image 对象
            let img = new Image();
            img.src = url;
            img.onload = () => {
                // console.log("============================3","write-text",url)
                let w = img.width;
                let h = img.height;
                img = null;
                URL.revokeObjectURL(url);
                callback({ width: w, height: h });
            };
        });
    },
    //获得图片的尺寸信息
    imageSizeRemote: function (url) {
        return new Promise(callback => {
            // 创建一个 Image 对象
            let img = new Image();
            img.src = url;
            img.onload = () => {
                let w = img.width;
                let h = img.height;
                img = null;
                callback({ width: w, height: h });
            };
        });
    },
    //水印
    waterMark: function (data1, size1, imageType1, data2, size2, imageType2, dx, dy) {
        return new Promise(callback => {
            let bigImg = {};
            let smallImg = {};
            if (size1.width * size1.height > size2.width * size2.height) {
                bigImg.data = data1;
                bigImg.size = size1;
                bigImg.imageType = imageType1;
                smallImg.data = data2;
                smallImg.size = size2;
                smallImg.imageType = imageType2;
            } else {
                bigImg.data = data2;
                bigImg.size = size2;
                bigImg.imageType = imageType2;
                smallImg.data = data1;
                smallImg.size = size1;
                smallImg.imageType = imageType1;
            }

            let blob1 = new Blob([bigImg.data], { type: bigImg.imageType });
            let url1 = URL.createObjectURL(blob1);
            let blob2 = new Blob([smallImg.data], { type: smallImg.imageType });
            let url2 = URL.createObjectURL(blob2);
            // 创建一个 Image 对象
            let img1 = new Image();
            let img2 = new Image();
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext('2d');
            canvas.width = bigImg.size.width > smallImg.size.width ? bigImg.size.width : smallImg.size.width;
            canvas.height = bigImg.size.height > smallImg.size.height ? bigImg.size.height : smallImg.size.height;
            let loaded = 0;
            let _this = this;
            let func = () => {
                loaded++;
                if (loaded === 2) {
                    //先写入大图
                    ctx.drawImage(img1, 0, 0);
                    //再写入小图
                    ctx.drawImage(img2, dx, dy);
                    let dataURL = canvas.toDataURL('image/jpeg');
                    let buf = _this.base64ToArrayBuffer(dataURL);
                    // console.log("buf",buf.length)
                    //  canvas.style.border = "1px solid #000";
                    // document.body.appendChild(canvas);
                    img1 = null;
                    blob1 = null;
                    img2 = null;
                    blob2 = null;
                    canvas = null;
                    ctx = null;
                    URL.revokeObjectURL(url1);
                    URL.revokeObjectURL(url2);
                    callback(buf);
                }
            };
            img1.onload = func;
            img2.onload = func;
            img1.src = url1;
            img2.src = url2;
        });
    },
    //图片裁剪
    cutImage: function (data, imageType, size, dx, dy, dw, dh) {
        return new Promise(callback => {
            let blob = new Blob([data], { type: imageType });
            let url = URL.createObjectURL(blob);
            // 创建一个 Image 对象
            let img = new Image();
            let canvas = document.createElement("canvas");
            canvas.width = size.width;
            canvas.height = size.height;
            img.src = url;
            let _this = this;
            img.onload = () => {
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, dx, dy, dw, dh, 0, 0, size.width, size.height);
                let dataURL = canvas.toDataURL('image/jpeg');
                let buf = _this.base64ToArrayBuffer(dataURL);
                // console.log("buf",buf.length)
                //  canvas.style.border = "1px solid #000";
                // document.body.appendChild(canvas);
                img = null;
                blob = null;
                canvas = null;
                ctx = null;
                URL.revokeObjectURL(url);
                callback(buf);
            };
        });
    },
    //图片裁剪
    paddingImage: function (data, imageType, size, dx, dy, dw, dh) {
        return new Promise(callback => {
            let blob = new Blob([data], { type: imageType });
            let url = URL.createObjectURL(blob);
            // 创建一个 Image 对象
            let img = new Image();
            let canvas = document.createElement("canvas");
            canvas.width = size.width;
            canvas.height = size.height;
            img.src = url;
            let _this = this;
            img.onload = () => {
                let ctx = canvas.getContext('2d');
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(img, dx, dy, dw, dh);
                let dataURL = canvas.toDataURL('image/jpeg');
                let buf = _this.base64ToArrayBuffer(dataURL);
                // console.log("buf",buf.length)
                //  canvas.style.border = "1px solid #000";
                // document.body.appendChild(canvas);
                img = null;
                blob = null;
                canvas = null;
                ctx = null;
                URL.revokeObjectURL(url);
                callback(buf);
            };
        });
    },
    //图片裁剪
    writeTextInImage: function (data, imageType, size, text, fontSize, color, x, y) {
        return new Promise(callback => {
            let blob = new Blob([data], { type: imageType });
            let url = URL.createObjectURL(blob);
            // 创建一个 Image 对象
            let img = new Image();
            let canvas = document.createElement("canvas");
            canvas.width = size.width;
            canvas.height = size.height;
            img.src = url;
            let _this = this;
            img.onload = () => {
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                ctx.textBaseline = 'top';
                ctx.font = fontSize + 'px Arial';
                ctx.fillStyle = color;
                ctx.fillText(text, x, y);
                let dataURL = canvas.toDataURL('image/jpeg');
                let buf = _this.base64ToArrayBuffer(dataURL);
                // console.log("buf",buf.length)
                //  canvas.style.border = "1px solid #000";
                // document.body.appendChild(canvas);
                img = null;
                blob = null;
                canvas = null;
                ctx = null;
                URL.revokeObjectURL(url);
                callback(buf);
            };
        });
    },
    //图片裁剪
    cutImageRemote: function (url, size, dx, dy, dw, dh) {
        return new Promise(callback => {
            // 创建一个 Image 对象
            let img = new Image();
            let canvas = document.createElement("canvas");
            canvas.width = size.width;
            canvas.height = size.height;
            img.src = url;
            let _this = this;
            img.onload = () => {
                let ctx = canvas.getContext('2d');
                ctx.drawImage(img, dx, dy, dw, dh, 0, 0, size.width, size.height);
                let dataURL = canvas.toDataURL('image/jpeg');
                let buf = _this.base64ToArrayBuffer(dataURL);
                // console.log("buf",buf.length)
                //  canvas.style.border = "1px solid #000";
                // document.body.appendChild(canvas);
                img = null;
                canvas = null;
                ctx = null;
                // console.log("销毁完毕");
                callback(buf);
            };
        });
    },
    //把图片切成多张
    cutImageHeight: async function (data, imageType, size, maxHeight) {
        // console.log("size",size);
        let needDuan = Math.ceil(size.height / maxHeight);
        let tmpHeight = 0;
        let rdata = [];
        for (let i = 0; i < needDuan; i++) {
            let shengYu = size.height - tmpHeight;
            let h = maxHeight;
            if (shengYu < maxHeight) {
                h = shengYu;
            }
            // console.log("高度:",h,"偏移高度",tmpHeight);
            let buf = await this.cutImage(data, imageType, { width: size.width, height: h }, 0, tmpHeight, size.width, h);
            tmpHeight = tmpHeight + maxHeight;

            let buffer = await this.gzip(buf);
            if (buffer) {
                rdata.push(buffer);
            }
        }
        return rdata;
    },
    gzip: function (data) {
        let zlib = require('zlib');
        return new Promise(r => {
            zlib.gzip(data, (err, buffer) => {
                if (err) {
                    r();
                    return;
                }
                r(buffer);
            });
        });
    },
    //把图片切成多张
    cutImageHeightRemote: async function (url, size, maxHeight, fileInfo) {
        let needDuan = Math.ceil(size.height / maxHeight);
        let tmpHeight = 0;
        let rdata = [];
        for (let i = 0; i < needDuan; i++) {
            let shengYu = size.height - tmpHeight;
            let h = maxHeight;
            if (shengYu < maxHeight) {
                h = shengYu;
            }
            let name = fileInfo.fileName + "-" + i + "." + fileInfo.ext;
            let tmpPath = Call.sendSync("fileEvent.getCachePath", "cache/download/image/" + name);
            let hasQieTuData = Call.sendSync("fileEvent.getCachePath", "cache/download/qietu/" + fileInfo.fileName + "-" + i + ".json");
            //缓存
            let cache = Call.sendSync("fileEvent.readJson", hasQieTuData, false, undefined, true);
            if (cache) {
                cache.isCache = true;
                rdata.push(cache);
                continue;
            }
            // console.log("高度:",h,"偏移高度",tmpHeight);
            let buf = await this.cutImageRemote(url, { width: size.width, height: h }, 0, tmpHeight, size.width, h);
            tmpHeight = tmpHeight + maxHeight;
            Call.sendSync("fileEvent.write", tmpPath, buf, false, undefined, true);
            let saveData = {
                name: name,
                fileName: fileInfo.fileName + "-" + i,
                path: tmpPath,
                size: buf.length,
                sizeStr: (buf.length / 1024 / 1024) + " M",
            };
            rdata.push(saveData);

            Call.sendSync("fileEvent.writeJson", hasQieTuData, saveData, false, undefined, true);
        }
        return rdata;
    },
    initWebView: async function (shop) {
        console.log("=====================创建webview", shop.idx)
        let key = "$instance-" + shop.id + "-" + shop.idx;
        let lockKey = "$instance-lock-" + shop.id + "-" + shop.idx;
        if (window[key] === undefined && !window[lockKey]) {
            window[lockKey] = true;
            const Constructor = Vue.extend(mywebviewnowinv2)
            const instance = new Constructor({
                propsData: { shop: shop }
            })
            instance.$mount()
            document.body.appendChild(instance.$el)
            await instance.init();
            window[key] = instance;
            window[lockKey] = false;
            console.log("===============初始化完毕", instance)
        }
        return key;
    },
    run: function (context) {
        // console.log("我加载了");
        //视频生成封面图
        Call.bind("video-gen-image", async (_event, url, filePath, width, height) => {
            return await this.videoGenImage(url, filePath, width, height);
        });
        //图片缩放
        Call.bind("image-resize", async (_event, data, imageType, filePath, width, height) => {
            return await this.reSizeImage(data, imageType, filePath, width, height);
        });
        //图片缩放
        Call.bind("image-resize-remote", async (_event, url, filePath, width, height) => {
            return await this.reSizeImageRemote(url, filePath, width, height);
        });
        //图片切成多张
        Call.bind("cut-image-height", async (_event, data, imageType, size, maxHeight) => {
            return await this.cutImageHeight(data, imageType, size, maxHeight);
        });
        //图片切成多张
        Call.bind("cut-image-height-remote", async (_event, url, size, maxHeight, fileInfo) => {
            return await this.cutImageHeightRemote(url, size, maxHeight, fileInfo);
        });
        //获得图片尺寸
        Call.bind("image-size", async (_event, data, imageType) => {
            return await this.imageSize(data, imageType);
        })
        //获得图片尺寸
        Call.bind("image-size-remote", async (_event, url) => {
            return await this.imageSizeRemote(url);
        })
        //获得图片尺寸
        Call.bind("save-remote-image", async (_event, url, filePath) => {
            return await this.saveRemoteImage(url, filePath);
        })
        //切图
        Call.bind("cut-image", async (_event, data, imageType, size, dx, dy, dw, dh) => {
            return await this.cutImage(data, imageType, size, dx, dy, dw, dh);
        })
        //补白图
        Call.bind("padding-image", async (_event, data, imageType, size, dx, dy, dw, dh) => {
            return await this.paddingImage(data, imageType, size, dx, dy, dw, dh);
        })
        //水印
        Call.bind("water-mark", async (_event, data1, imageType1, data2, imageType2, dx, dy) => {
            let size1 = await this.imageSize(data1, imageType1);
            let size2 = await this.imageSize(data2, imageType2);
            return await this.waterMark(data1, size1, imageType1, data2, size2, imageType2, dx, dy);
        })
        Call.bind("message-test", async (_event, msg) => {
            console.log("===============测试消息:", msg);
        });
        //写入文字
        Call.bind("write-text", async (_event, data, imageType, text, fontSize, color, x, y) => {
            console.log("调用写入文字", text)
            // console.log("============================1","write-text",data, imageType, text, fontSize, color, x, y)
            let size = await this.imageSize(data, imageType);
            // console.log("xxxxxxxxxxxxxxxxxxxx",size)
            return await this.writeTextInImage(data, imageType, size, text, fontSize, color, x, y);
        })
        //获得上架商品数据
        Call.bind("get-copy-product-ids", async (_event) => {
            return context.rootGetters["product/getCopyProductIds"];
        });
        //获得上架商品数据
        Call.bind("get-copy-product-ids-v2", async (_event, input) => {
            let rs = context.dispatch("product/getCopyProductIdsV2", input, { root: true });
            // console.log("=-------------------------",rs)
            return rs;
        });
        //获得抓取商品url
        Call.bind("get-copy-read-link", async (_event) => {
            const data = context.rootGetters["product/getCopyReadLinkUrls"];
            console.log("[读取诊断] get-copy-read-link", data);
            return data;
        });
        Call.bind("get-default-template", async (_event) => {
            return context.rootGetters["product/getDefaultTemplate"];
        });
        Call.bind("get-copy-success-id", async (_event) => {
            return context.rootGetters["product/getCopySuccessIds"];
        });
        Call.bind("get-copy-jump-id", async (_event) => {
            return context.rootGetters["product/getCopyJumpIds"];
        });
        //写入状态
        Call.bind("get-publish-status", async (_event) => {
            return context.rootGetters["product/getOnOff"];
        });
        //更新状态
        Call.bind("update-publish-state", async (_event, state) => {
            console.log(common.formatDateHHmmss(common.now()) + "-state", state);
            return context.commit("product/updateState", state, { root: true });
        });
        //更新统计值
        Call.bind("update-publish-count", async (_event, input) => {
            return context.commit("product/updateCount", input, { root: true });
        });
        //更新商品
        Call.bind("update-publish-product", async (_event, input) => {
            return context.commit("product/updatePublishProduct", input, { root: true });
        });
        Call.bind("update-pdd-product", async (_event, input) => {
            return context.dispatch("product/onReadPddProduct", input, { root: true });
        });
        Call.bind("update-pdd-tongji", async (_event, input) => {
            return context.commit("product/updateReadPddTongJi", input, { root: true });
        });

        //更新状态
        Call.bind("update-pdd-state", async (_event, state) => {
            return context.commit("product/pddUpdateState", state, { root: true });
        });
        //写入状态
        Call.bind("get-pdd-read-state", async (_event) => {
            return context.rootGetters["product/getPddOnOff"];
        });
        //添加拼多多商品
        Call.bind("add-pdd-product", async (_event, input) => {
            return context.commit("product/addPddProduct", input, { root: true });
        });
        //发送更新日志
        Call.bind("publish-log", async (_event, msg) => {
            return context.commit("product/writeCopyLog", msg, { root: true });
        });
        //写入状态
        Call.bind("get-wang-status", async (_event) => {
            return context.rootGetters["product/getWangOnOff"];
        });
        //获得搬家状态
        Call.bind("get-banjia-state", async (_event) => {
            return context.rootGetters["product/getBanJiaStatus"];
        });
        //设置搬家状态
        Call.bind("set-banjia-state", async (_event, input) => {
            return context.commit("product/setBanJiaStatus", input, { root: true });
        });


        //获得商机状态
        Call.bind("get-shangji-state", async (_event) => {
            return context.rootGetters["product/getShangjiStatus"];
        });
       
        //设置商机状态
        Call.bind("set-shangji-state", async (_event, input) => {
            return context.commit("product/setShangJiState", input, { root: true });
        });
        Call.bind("get-shangji-collect-state", async (_event) => {
            return context.rootGetters["product/getShangJiCollectStatus"];
        });
        Call.bind("set-shangji-collect-state", async (_event, input) => {
            return context.commit("product/setShangJiCollectState", input, { root: true });
        });
        //获得批量修改标题状态
        Call.bind("get-batch-edit-titles-state", async (_event) => {
            return context.rootGetters["product/getBatchEditTitlesStatus"];
        });
        //设置批量修改标题状态
        Call.bind("set-batch-edit-titles-state", async (_event, input) => {
            return context.commit("product/setTitleState", input, { root: true });
        });
        Call.bind("set-batch-edit-titles-result", async (_event, input) => {
            return context.commit("product/setBatchEditTitleResult", input, { root: true });
        });

        Call.bind("get-batch-edit-sku-price-state", async (_event) => {
            return context.rootGetters["product/getBatchEditSkuPricesStatus"];
        });
        Call.bind("set-batch-edit-sku-price-state", async (_event, input) => {
            return context.commit("product/setSkuPriceState", input, { root: true });
        });
        Call.bind("set-batch-edit-sku-price-result", async (_event, input) => {
            return context.commit("product/setBatchEditSkuPriceResult", input, { root: true });
        });
        Call.bind("get-batch-preview-sku-price-state", async (_event) => {
            return context.rootGetters["product/getBatchPreviewSkuPricesStatus"];
        });
        Call.bind("set-batch-preview-sku-price-state", async (_event, input) => {
            return context.commit("product/setSkuPricePreviewState", input, { root: true });
        });

        //获得批量修改标题状态
        Call.bind("get-batch-edit-short-titles-state", async (_event) => {
            return context.rootGetters["product/getBatchEditShortTitlesStatus"];
        });
        Call.bind("set-batch-edit-short-titles-state", async (_event, input) => {
            return context.commit("product/setShortTitleState", input, { root: true });
        });
        Call.bind("set-batch-edit-short-titles-result", async (_event, input) => {
            return context.commit("product/setBatchEditShortTitleResult", input, { root: true });
        });

        Call.bind("get-batch-edit-brands-state", async (_event) => {
            return context.rootGetters["product/getBatchEditBrandsStatus"];
        });
        Call.bind("set-batch-edit-brands-state", async (_event, input) => {
            return context.commit("product/setBrandState", input, { root: true });
        });
        Call.bind("set-batch-edit-brands-result", async (_event, input) => {
            return context.commit("product/setBatchEditBrandResult", input, { root: true });
        });
        Call.bind("get-batch-edit-aftersale-state", async (_event) => {
            return context.rootGetters["product/getBatchEditAftersaleStatus"];
        });
        Call.bind("set-batch-edit-aftersale-state", async (_event, input) => {
            return context.commit("product/setAftersaleState", input, { root: true });
        });
        Call.bind("set-batch-edit-aftersale-result", async (_event, input) => {
            return context.commit("product/setBatchEditAftersaleResult", input, { root: true });
        });
        Call.bind("get-batch-edit-category-attrs-state", async (_event) => {
            return context.rootGetters["product/getBatchEditCategoryAttrsStatus"];
        });
        Call.bind("set-batch-edit-category-attrs-state", async (_event, input) => {
            return context.commit("product/setAttrState", input, { root: true });
        });
        Call.bind("set-batch-edit-category-attrs-result", async (_event, input) => {
            return context.commit("product/setBatchEditAttrResult", input, { root: true });
        });
        Call.bind("get-batch-edit-fabric-material-state", async (_event) => {
            return context.rootGetters["product/getBatchEditFabricStatus"];
        });
        Call.bind("set-batch-edit-fabric-material-state", async (_event, input) => {
            return context.commit("product/setFabricState", input, { root: true });
        });
        Call.bind("set-batch-edit-fabric-material-result", async (_event, input) => {
            return context.commit("product/setBatchEditFabricResult", input, { root: true });
        });
        Call.bind("get-batch-edit-freight-state", async (_event) => {
            return context.rootGetters["product/getBatchEditFreightStatus"];
        });
        Call.bind("set-batch-edit-freight-state", async (_event, input) => {
            return context.commit("product/setFreightState", input, { root: true });
        });
        Call.bind("set-batch-edit-freight-result", async (_event, input) => {
            return context.commit("product/setBatchEditFreightResult", input, { root: true });
        });

        Call.bind("get-batch-offline-delete-state", async (_event) => {
            return context.rootGetters["product/getBatchOfflineDeleteStatus"];
        });
        Call.bind("set-batch-offline-delete-state", async (_event, input) => {
            return context.commit("product/setOfflineDeleteState", input, { root: true });
        });
        Call.bind("set-batch-offline-delete-result", async (_event, input) => {
            return context.commit("product/setBatchOfflineDeleteResult", input, { root: true });
        });
        Call.bind("set-batch-offline-delete-progress", async (_event, input) => {
            return context.commit("product/setOfflineDeleteProgress", input, { root: true });
        });

        Call.bind("get-drafts-web-release-state", async (_event) => {
            return context.rootGetters["product/getDraftsWebReleaseStatus"];
        });
        Call.bind("set-drafts-web-release-state", async (_event, input) => {
            return context.commit("product/setDraftsWebReleaseState", input, { root: true });
        });
        Call.bind("set-drafts-web-release-progress", async (_event, input) => {
            return context.commit("product/setDraftsWebReleaseProgress", input, { root: true });
        });

        Call.bind("get-dead-stock-analyze-state", async (_event) => {
            return context.rootGetters["product/getDeadStockAnalyzeStatus"];
        });
        Call.bind("set-dead-stock-analyze-state", async (_event, input) => {
            const st = Number(input);
            if (st === 3) {
                try {
                    void Call.invoke(
                        "douDianBatchOperationProduct.cancelDeadStockAnalysis",
                    );
                } catch (e) {
                    /* worker 未启动时忽略 */
                }
            }
            return context.commit("product/setDeadStockAnalyzeState", input, { root: true });
        });
        Call.bind("set-dead-stock-analyze-progress", async (_event, input) => {
            return context.commit("product/setDeadStockAnalyzeProgress", input, { root: true });
        });
        Call.bind("append-dead-stock-analyze-item", async (_event, input) => {
            return context.commit("product/appendDeadStockAnalyzeItem", input, { root: true });
        });
        Call.bind("set-dead-stock-lists", async (_event, input) => {
            return context.commit("product/setDeadStockLists", input, { root: true });
        });
        Call.bind("get-dead-stock-batch-state", async (_event) => {
            return context.rootGetters["product/getDeadStockBatchStatus"];
        });
        Call.bind("set-dead-stock-batch-state", async (_event, input) => {
            const st = Number(input);
            if (st === 3) {
                try {
                    void Call.invoke("douDianBatchOperationProduct.cancelDeadStockBatch");
                } catch (e) {
                    /* worker 未启动时忽略 */
                }
            }
            return context.commit("product/setDeadStockBatchState", input, { root: true });
        });
        Call.bind("set-dead-stock-batch-progress", async (_event, input) => {
            context.commit("product/setDeadStockBatchProgress", input, { root: true });
            try {
                const st = Number(context.rootGetters["product/getDeadStockBatchStatus"]);
                const total = input && Number(input.total);
                const done = input && Number(input.done);
                if (
                    st === 2 &&
                    Number.isFinite(total) &&
                    total > 0 &&
                    Number.isFinite(done) &&
                    done >= total
                ) {
                    setTimeout(() => {
                        const st2 = Number(context.rootGetters["product/getDeadStockBatchStatus"]);
                        if (st2 === 2) {
                            context.commit("product/setDeadStockBatchState", 5, { root: true });
                        }
                    }, 200);
                }
            } catch (e) {
                /* ignore */
            }
            return true;
        });
        Call.bind("set-dead-stock-batch-result", async (_event, input) => {
            return context.commit("product/setDeadStockBatchResult", input, { root: true });
        });

        Call.bind("get-low-quality-fetch-state", async (_event) => {
            return context.rootGetters["product/getLowQualityFetchStatus"];
        });
        Call.bind("set-low-quality-fetch-state", async (_event, input) => {
            const st = Number(input);
            if (st === 3) {
                try {
                    void Call.invoke("douDianBatchOperationProduct.cancelLowQualityFetch");
                } catch (e) {
                    /* worker 未启动时忽略 */
                }
            }
            return context.commit("product/setLowQualityFetchState", input, { root: true });
        });
        Call.bind("set-low-quality-fetch-progress", async (_event, input) => {
            return context.commit("product/setLowQualityFetchProgress", input, { root: true });
        });
        Call.bind("append-low-quality-item", async (_event, input) => {
            return context.commit("product/appendLowQualityItem", input, { root: true });
        });
        Call.bind("set-low-quality-list", async (_event, input) => {
            return context.commit("product/setLowQualityList", input, { root: true });
        });
        Call.bind("get-low-quality-batch-state", async (_event) => {
            return context.rootGetters["product/getLowQualityBatchStatus"];
        });
        Call.bind("set-low-quality-batch-state", async (_event, input) => {
            const st = Number(input);
            if (st === 3) {
                try {
                    void Call.invoke("douDianBatchOperationProduct.cancelLowQualityBatch");
                } catch (e) {
                    /* worker 未启动时忽略 */
                }
            }
            return context.commit("product/setLowQualityBatchState", input, { root: true });
        });
        Call.bind("set-low-quality-batch-progress", async (_event, input) => {
            context.commit("product/setLowQualityBatchProgress", input, { root: true });
            try {
                const st = Number(context.rootGetters["product/getLowQualityBatchStatus"]);
                const total = input && Number(input.total);
                const done = input && Number(input.done);
                if (
                    st === 2 &&
                    Number.isFinite(total) &&
                    total > 0 &&
                    Number.isFinite(done) &&
                    done >= total
                ) {
                    setTimeout(() => {
                        const st2 = Number(context.rootGetters["product/getLowQualityBatchStatus"]);
                        if (st2 === 2) {
                            context.commit("product/setLowQualityBatchState", 5, { root: true });
                        }
                    }, 200);
                }
            } catch (e) {
                /* ignore */
            }
            return true;
        });
        Call.bind("set-low-quality-batch-result", async (_event, input) => {
            return context.commit("product/setLowQualityBatchResult", input, { root: true });
        });
        Call.bind("get-quality-diagnose-fetch-state", async (_event) => {
            return context.rootGetters["product/getQualityDiagnoseFetchStatus"];
        });
        Call.bind("set-quality-diagnose-fetch-state", async (_event, input) => {
            const st = Number(input);
            if (st === 3) {
                try {
                    void Call.invoke("douDianBatchOperationProduct.cancelQualityDiagnoseFetch");
                } catch (e) {
                    /* worker 未启动时忽略 */
                }
            }
            return context.commit("product/setQualityDiagnoseFetchState", input, { root: true });
        });
        Call.bind("set-quality-diagnose-fetch-progress", async (_event, input) => {
            return context.commit("product/setQualityDiagnoseFetchProgress", input, { root: true });
        });
        Call.bind("append-quality-diagnose-item", async (_event, input) => {
            return context.commit("product/appendQualityDiagnoseItem", input, { root: true });
        });
        Call.bind("set-quality-diagnose-list", async (_event, input) => {
            return context.commit("product/setQualityDiagnoseList", input, { root: true });
        });
        Call.bind("get-quality-diagnose-batch-state", async (_event) => {
            return context.rootGetters["product/getQualityDiagnoseBatchStatus"];
        });
        Call.bind("set-quality-diagnose-batch-state", async (_event, input) => {
            const st = Number(input);
            if (st === 3) {
                try {
                    void Call.invoke("douDianBatchOperationProduct.cancelQualityDiagnoseBatch");
                } catch (e) {
                    /* worker 未启动时忽略 */
                }
            }
            return context.commit("product/setQualityDiagnoseBatchState", input, { root: true });
        });
        Call.bind("set-quality-diagnose-batch-progress", async (_event, input) => {
            context.commit("product/setQualityDiagnoseBatchProgress", input, { root: true });
            try {
                const st = Number(context.rootGetters["product/getQualityDiagnoseBatchStatus"]);
                const total = input && Number(input.total);
                const done = input && Number(input.done);
                if (
                    st === 2 &&
                    Number.isFinite(total) &&
                    total > 0 &&
                    Number.isFinite(done) &&
                    done >= total
                ) {
                    setTimeout(() => {
                        const st2 = Number(context.rootGetters["product/getQualityDiagnoseBatchStatus"]);
                        if (st2 === 2) {
                            context.commit("product/setQualityDiagnoseBatchState", 5, { root: true });
                        }
                    }, 200);
                }
            } catch (e) {
                /* ignore */
            }
            return true;
        });
        Call.bind("set-quality-diagnose-batch-result", async (_event, input) => {
            return context.commit("product/setQualityDiagnoseBatchResult", input, { root: true });
        });
        Call.bind("low-quality-schedule-notify", async (_event, input) => {
            const payload = input || {};
            context.commit("product/setLowQualityScheduleNotify", payload, { root: true });
            const level = payload.level || "info";
            const msg = String(payload.msg || "定时清理低质商品已更新").slice(0, 300);
            const opts = {
                message: msg,
                duration: level === "error" ? 12000 : level === "warning" ? 10000 : 6000,
                showClose: true,
            };
            if (level === "error") {
                Message.error(opts);
            } else if (level === "warning") {
                Message.warning(opts);
            } else if (level === "success") {
                Message.success(opts);
            } else {
                Message.info(opts);
            }
            return true;
        });

        //新增商机日志
        Call.bind("add-shangji-log", async (_event, input) => {
            return context.commit("product/addShangJiLog", input, { root: true });
        });
        Call.bind("add-shangji-log-batch", async (_event, input) => {
            return context.commit("product/addShangJiLogsBatch", input, { root: true });
        });
        Call.bind("add-shangji-collect-log", async (_event, input) => {
            return context.commit("product/addShangJiCollectLog", input, { root: true });
        });
        //商机设置滑块店铺
        Call.bind("set-shangji-huashop", async (_event, input) => {
            return context.commit("product/setHuaShop", input, { root: true });
        });


        //写入状态
        Call.bind("get-wang-read-config", async (_event) => {
            return context.rootGetters["product/getWangConfig"];
        });
        Call.bind("get-wang-init-queue", async (_event) => {
            const data = context.rootGetters["product/getWangInitQueue"];
            console.log("[读取诊断] get-wang-init-queue", data);
            return data;
        });
        //更新状态
        Call.bind("update-wang-publish", async (_event, state) => {
            const prevState = context.rootState.product.readConfig.STATE;
            context.commit("product/wangUpdateState", state, { root: true });
            if (state === 4 && prevState !== 4) {
                const rc = context.rootState.product.readConfig;
                if (rc.TOTAL > 0 && rc.SUCCESS_ACOUNT === 0) {
                    if (rc.FAIL_ACOUNT > 0) {
                        Message.warning(`读取完成：成功 ${rc.SUCCESS_ACOUNT} 条，失败 ${rc.FAIL_ACOUNT} 条，请查看失败原因`);
                    } else {
                        Message.warning("读取完成但未获取到商品，请重试；若仍失败请重启软件");
                    }
                }
            }
            return { code: 1 };
        });
        //更新统计值
        Call.bind("update-wang-count", async (_event, input) => {
            return context.dispatch("product/onWangProductUpdate", input, { root: true });
        });
        Call.bind("update-wang-jumpproduct", async (_event, input) => {
            return context.commit("product/jumpproduct", input, { root: true });
        });

        //检测新版本
        Call.bind("update-available", async (_event, input) => {
            if (window.$updateload) {
                window.$updateload.show(input);
            }
        });
        //新版本下载进度
        Call.bind("download-progress", async (_event, input) => {
            if (window.$updateload) {
                window.$updateload.updatePercentage(input);
            }
        });
        Call.bind("update-downloaded", async (_event) => {
            if (window.$updateload) {
                window.$updateload.finishDonwload();
            }
        });

        Call.bind("call-in-webview", async (_event, params) => {
            // console.log("====================调用参数params",params)
            let { shop, action } = params;
            let key = await this.initWebView(shop);
            if (window[key]) {
                console.log("==================调用跳转到发布页面")
                return await window[key].callMethod(action, params);
            } else {
                return { code: -1, msg: "初始化webview失败" }
            }
        });
        Call.bind("go-page-in-webview", async (_event, shop, url) => {
            let key = await this.initWebView(shop);
            if (window[key]) {
                console.log("==================跳转")
                return await window[key].goPage(shop, url);
            } else {
                return { code: -1, msg: "初始化webview失败" }
            }
        });
        Call.bind("publish-in-webview", async (_event, shop, schema) => {
            let key = await this.initWebView(shop);
            if (window[key]) {
                console.log("==================调用上架")
                return await window[key].publish(shop, schema);
            } else {
                return { code: -1, msg: "初始化webview失败" }
            }
        });

        Call.bind("edit-publish-in-webview", async (_event, shop, schema) => {
            let key = await this.initWebView(shop);
            if (window[key]) {
                return await window[key].editPublish(shop, schema);
            } else {
                return { code: -1, msg: "初始化webview失败" }
            }
        });

        Call.bind("qianchuan-message-warning", async (_event, data) => {
            try {
                const msg = new SpeechSynthesisUtterance(data?.msg);
                msg.lang = "zh-CN";   // 中文
                msg.rate = 1.2;         // 语速
                msg.pitch = 1;        // 音调
                msg.volume = 10;       // 音量
                speechSynthesis.speak(msg);
            } catch (e) { }
        });

        Call.bind("kefu-smart-reply-update", async (_event, payload) => {
            return context.dispatch("kefuSmartReply/onWorkerUpdate", payload, { root: true });
        });

        // 乘方计划：视频上传进度（thread → 主进程 → 渲染层），经全局事件总线分发给页面弹窗
        if (!window.cfProgressBus) {
            window.cfProgressBus = new Vue();
        }
        Call.bind("cf-upload-progress", async (_event, payload) => {
            try {
                window.cfProgressBus.$emit("cf-upload-progress", payload);
            } catch (e) { }
        });
        Call.bind("cf-load-progress", async (_event, payload) => {
            try {
                window.cfProgressBus.$emit("cf-load-progress", payload);
            } catch (e) { }
        });
        // 创建计划进度（成功/失败逐条实时推送，全域 qy 与乘方 cf 共用，payload.planType 区分）
        Call.bind("cf-create-progress", async (_event, payload) => {
            try {
                window.cfProgressBus.$emit("cf-create-progress", payload);
            } catch (e) { }
        });
        // 千川数据：批量刷新进度（thread → 主进程 → 渲染层）
        Call.bind("qc-data-refresh-progress", async (_event, payload) => {
            try {
                window.cfProgressBus.$emit("qc-data-refresh-progress", payload);
            } catch (e) { }
        });
    },
}